import { render, staticRenderFns } from "./point.vue?vue&type=template&id=95162564&scoped=true"
import script from "./point.vue?vue&type=script&lang=js"
export * from "./point.vue?vue&type=script&lang=js"
import style0 from "./point.vue?vue&type=style&index=0&id=95162564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95162564",
  null
  
)

export default component.exports